import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, unref as _unref, withCtx as _withCtx, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass } from "vue"
import _imports_0 from '@/assets/img/icon/suitcase-outline-black.svg'
import _imports_1 from '@/assets/img/icon/check-circle-green.svg'
import _imports_2 from '@/assets/img/icon/edit-box-green.svg'
import _imports_3 from '@/assets/img/icon/delete-box-red.svg'


const _hoisted_1 = { class: "employee-contract-list" }
const _hoisted_2 = { class: "flex items-center mb-2 gap-4" }
const _hoisted_3 = ["innerHTML"]
const _hoisted_4 = { class: "flex items-top gap-4" }
const _hoisted_5 = { class: "flex items-center gap-3" }
const _hoisted_6 = { class: "text-xl font-bold" }
const _hoisted_7 = { key: 0 }
const _hoisted_8 = { class: "text-lg font-semibold mb-1" }
const _hoisted_9 = { class: "flex items-center mb-1" }
const _hoisted_10 = { class: "text-grey-5 text-base" }
const _hoisted_11 = {
  key: 0,
  class: "text-grey-5 px-2"
}
const _hoisted_12 = { class: "text-grey-5 text-base" }
const _hoisted_13 = { class: "text-grey-5 text-base mb-1" }
const _hoisted_14 = { class: "text-grey-5 text-base" }
const _hoisted_15 = {
  key: 0,
  class: "flex gap-3"
}
const _hoisted_16 = ["onClick"]
const _hoisted_17 = ["onClick"]

import { computed, getCurrentInstance, onMounted, ref } from 'vue'
import { useStore } from 'vuex'
import { useRoute } from 'vue-router'
import Button from 'primevue/button'
import moment from 'moment'
import HjpDefaultModal from '@/views/components/modal/ModalDefault.vue'
import apiUseCase from '@/usecase/apiUseCase'
import { encryptDecriptMethods } from '@/plugins/encryptDecriptMethods'
import HjpCofirmModal from '@/views/components/modal/HjpConfirmationModal.vue'
import EditContractForm from './dialog/EditContractForm.vue'

const employeeEndpoint = 'talent/v1/employees'
const employmentEndpoint = 'talent/v1/employments'

export default /*@__PURE__*/_defineComponent({
  __name: 'EmployeeContractList',
  setup(__props) {

const store = useStore()
const route = useRoute()
const app = getCurrentInstance()
const {
  $icon, $toast
} = app!.appContext.config.globalProperties
const icon = $icon
const showDialogForm = ref(false)
const showConfirmDialog = ref(false)
const onSelectedData = ref(null) as any
const dataSource = ref(store.getters['employee/getEmployeeEmployments'])
const idPrams = ref(null) as any

const confirmDialogDelete = ref({
  title: 'Akhiri Kontrak Divisi?',
  subTitle: 'Kontrak Divisi saat ini sedang aktif. Apakah Anda yakin untuk menonaktifkan dan mengakhiri status kontrak Divisi saat ini?',
  btnSubmitTitle: 'Akhiri Kontrak',
  image: require('@/assets/img/modal-confirmation/end-contract.svg')
})

const redirectAdd = () => {
  console.log('add')
  onSelectedData.value = null
  showDialogForm.value = true
}
const hideDialogForm = () => {
  showDialogForm.value = false
}

const onEditContract = (value: any) => {
  onSelectedData.value = value
  showDialogForm.value = true
}

const countDiffDate = (startDate: string, endDate: string) => {
  const start = moment(startDate)
  const end = moment(endDate)

  const years = end.diff(start, 'years')
  const afterYears = start.clone().add(years, 'years')

  const months = end.diff(afterYears, 'months')
  const afterMonths = afterYears.clone().add(months, 'months')

  const days = end.diff(afterMonths, 'days')

  console.log([years, afterYears, months, afterMonths, days])
  const parts = []
  if (years > 0) parts.push(`${years} tahun`)
  if (months > 0) parts.push(`${months} bulan`)
  if (days > 0) parts.push(`${days} hari`)

  return parts.join(' ') || '0 hari'
}

const sortDataSource = (dataArray: any) => {
  // console.log('dataArray', dataArray)
  dataSource.value = dataArray.sort((a: any, b: any) => Number(b.isActive) - Number(a.isActive))
}

const getEmployeeDetailData = async () => {
  // console.log('reloadHeader')
  store.dispatch('showLoading')
  await apiUseCase.get(`${employeeEndpoint}/${idPrams.value.id}`).then((response) => {
    const { error, result } = response
    if (!error) {
      // console.log('result', result)
      store.dispatch('employee/setEmployeeData', result)
      sortDataSource(result.employments)
      // dataSource.value = store.getters['employee/getEmployeeEmployments']
    }
  })
  store.dispatch('hideLoading')
}

const onDeleteProcess = async () => {
  console.log('selected', onSelectedData.value)
  store.dispatch('showLoading')
  try {
    await apiUseCase.get(`${employmentEndpoint}/${onSelectedData.value?.id}`).then(async (response) => {
      const { error, result } = response
      if (!error) {
        const payload = {
          id: result.id,
          employeeId: result.employeeId,
          employmentTypeId: result.employmentTypeId,
          positionId: result.positionId,
          regionId: result.regionId,
          startDate: result.startDate ? moment(result.startDate).format('YYYY-MM-DD') : null,
          endDate: moment().format('YYYY-MM-DD'),
          remarks: result?.remarks
        }
        await apiUseCase.put(`${employmentEndpoint}/${onSelectedData.value?.id}`, payload).then((responseUpdate) => {
          // eslint-disable-next-line @typescript-eslint/no-shadow
          const { error } = responseUpdate
          if (!error) {
            $toast.add({
              severity: 'success',
              detail: 'Kontrak berhasil diakhiri',
              group: 'bc',
              closable: false,
              life: 3000
            })
            getEmployeeDetailData()
          } else {
            $toast.add({
              severity: 'error',
              detail: 'Kontrak gagal diakhiri',
              group: 'bc',
              closable: false,
              life: 3000
            })
          }
        })
      }
    })
  } catch (error) {
    $toast.add({
      severity: 'error',
      detail: 'Kontrak gagal diakhiri',
      group: 'bc',
      closable: false,
      life: 3000
    })
  }
  // eslint-disable-next-line no-use-before-define
  hideDialogConfirmation()
  store.dispatch('hideLoading')
}

const showDialogConfirmation = (data: any) => {
  onSelectedData.value = data
  showConfirmDialog.value = true
}

const hideDialogConfirmation = () => {
  showConfirmDialog.value = false
}

onMounted(() => {
  if (route.params.id) {
    idPrams.value = encryptDecriptMethods.decrypt(route.params.id)
  }
  sortDataSource(dataSource.value)
  // dataSource.value = store.getters['employee/getEmployeeEmployments']
  console.log('dataSource', dataSource.value)
})

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _cache[1] || (_cache[1] = _createElementVNode("div", { class: "font-bold text-xl" }, "Kontrak Divisi", -1)),
        _createElementVNode("div", null, [
          _createVNode(_unref(Button), {
            class: "sm:mb-0 flex gap-2 small-button",
            onClick: _cache[0] || (_cache[0] = ($event: any) => (redirectAdd()))
          }, {
            default: _withCtx(() => [
              _createElementVNode("span", {
                innerHTML: _unref(icon).svg.plusEva
              }, null, 8, _hoisted_3)
            ]),
            _: 1
          })
        ])
      ]),
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(dataSource.value, (data) => {
        return (_openBlock(), _createElementBlock("div", { key: data }, [
          _createElementVNode("div", {
            class: _normalizeClass(["flex items-top gap-4 justify-between py-30px px-4 mb-4", !data.isActive ? 'background-grey-2' : ''])
          }, [
            _createElementVNode("div", _hoisted_4, [
              _cache[3] || (_cache[3] = _createElementVNode("div", null, [
                _createElementVNode("img", {
                  src: _imports_0,
                  alt: "suitcase"
                })
              ], -1)),
              _createElementVNode("div", null, [
                _createElementVNode("div", _hoisted_5, [
                  _createElementVNode("div", _hoisted_6, _toDisplayString(`${data.positionName}`), 1),
                  (data.isActive)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_7, _cache[2] || (_cache[2] = [
                        _createElementVNode("img", {
                          src: _imports_1,
                          alt: "check"
                        }, null, -1)
                      ])))
                    : _createCommentVNode("", true)
                ]),
                _createElementVNode("div", _hoisted_8, _toDisplayString(`${data.regionName}`), 1),
                _createElementVNode("div", _hoisted_9, [
                  _createElementVNode("div", _hoisted_10, _toDisplayString(`${_unref(moment)(data.startDate).format('DD MMMM YYYY')} - ${data.endDate ? _unref(moment)(data.endDate).format('DD MMMM YYYY') : 'sekarang'}`), 1),
                  (countDiffDate(data.startDate, data.endDate) != '0 hari')
                    ? (_openBlock(), _createElementBlock("div", _hoisted_11, "|"))
                    : _createCommentVNode("", true),
                  _createElementVNode("div", _hoisted_12, _toDisplayString(`${countDiffDate(data.startDate, data.endDate) === '0 hari' ? '' : countDiffDate(data.startDate, data.endDate)}`), 1)
                ]),
                _createElementVNode("div", _hoisted_13, _toDisplayString(`${data.employmentTypeName}`), 1),
                _createElementVNode("div", _hoisted_14, _toDisplayString(`Keterangan: ${data.remarks}`), 1)
              ])
            ]),
            (data.isActive)
              ? (_openBlock(), _createElementBlock("div", _hoisted_15, [
                  _createElementVNode("img", {
                    src: _imports_2,
                    style: {"width":"40px","height":"40px"},
                    alt: "edit",
                    class: "cursor-pointer",
                    onClick: ($event: any) => (onEditContract(data?.id))
                  }, null, 8, _hoisted_16),
                  _createElementVNode("img", {
                    src: _imports_3,
                    style: {"width":"40px","height":"40px"},
                    alt: "delete",
                    class: "cursor-pointer",
                    onClick: ($event: any) => (showDialogConfirmation(data))
                  }, null, 8, _hoisted_17)
                ]))
              : _createCommentVNode("", true)
          ], 2)
        ]))
      }), 128))
    ]),
    _createVNode(HjpDefaultModal, {
      show: showDialogForm.value,
      width: '90vw',
      onHideDialog: hideDialogForm
    }, {
      content: _withCtx(() => [
        _createVNode(EditContractForm, {
          onOnHideDialog: hideDialogForm,
          id: onSelectedData.value,
          onReloadList: getEmployeeDetailData
        }, null, 8, ["id"])
      ]),
      _: 1
    }, 8, ["show"]),
    _createVNode(HjpCofirmModal, {
      show: showConfirmDialog.value,
      title: confirmDialogDelete.value?.title,
      subTitle: confirmDialogDelete.value?.subTitle,
      btnSubmitTitle: confirmDialogDelete.value?.btnSubmitTitle,
      onHideDialog: hideDialogConfirmation,
      onOnSubmit: onDeleteProcess,
      imgContent: confirmDialogDelete.value.image
    }, null, 8, ["show", "title", "subTitle", "btnSubmitTitle", "imgContent"])
  ], 64))
}
}

})